module.exports = __webpack_public_path__ + "static/media/a_of_hearts.7f9d5305.png";